import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom"; // ✅ Import Link for navigation
import { FaDraftingCompass, FaRulerCombined, FaPeopleArrows, FaDrawPolygon } from "react-icons/fa";
import { GiCube } from "react-icons/gi";
import "./Services.css";

const servicesData = [
  {
    title: "3D Modelling",
    description: (
      <ul> 
        <li>Complete 3D Services for Plant</li>
        <li>All Levels of Detailing(<b>LoD</b> to Enable BIM)</li>
      </ul>
      
    ),
    icon: <GiCube className="service-icon" />,
    image: "/3d.jpg",
    link: "/3d-modeling",
  },

    {
    title: "Design & Engineering",
    // description: "For a full end-to-end project, from structural to civil design, We do it all.",
    description: (
      <ul>
        <li>Multi-Disciplinary Design Services</li>
        
      </ul>
    ),
    icon: <FaDrawPolygon className="service-icon" />,
    image: "/design.jpg",
    link: "/design-services",
  },

  {
    title: "Detail Engineering",
    // description: "2D drafting services for Civil.",
    description: (
      <ul>
        <li>2D Drafting Services </li>
</ul>
    ),
    icon: <FaDraftingCompass className="service-icon" />,
    image: "/Picture1.jpg",
    link: "/2d-modeling", // ✅ Correct route for navigation
  },
  

  // {
  //   title: "Quantity Survey",
  //   description: "We provide you first class services in Civil Quantification, Bar Bending Scheduling, Piping ISO, and Spooling.",
  //   icon: <FaRulerCombined className="service-icon" />,
  //   image: "/civil.jpg",
  //   link: "/quantity-survey",
  // },
  // {
  //   title: "Engineering Support",
  //   description: "If you are looking for manpower, we also have teams ready for taking up posts in your premises.",
  //   icon: <FaPeopleArrows className="service-icon" />,
  //   image: "/outsourcing.jpg",
  //   link: "/manpower-outsourcing",
  // },
  // {
  //   title: "T&D",
  //   description: "We provide you with the best T&D services in the industry.",
  //   icon: <FaPeopleArrows className="service-icon" />,
  //   image: "/tandd.jpg",
  //   link: "/tandd",
  // }
];

const Services = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <Container className="services-section my-3">
      <h3 className="text-primary text-uppercase">OUR SERVICES</h3>
      {/* <h2 className="fw-bold">Best 3D Service For Your Business</h2> */}

      <Row className="mt-4">
        {servicesData.map((service, index) => (
          <Col md={4} sm={6} key={index} className="mb-4">
            <Card
              className={`service-card service-card-${(index % 3) + 1} ${hoveredIndex === index ? "hovered" : ""}`}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <Card.Body>
                <div className={`icon-container ${hoveredIndex === index ? "hide-icon" : ""}`}>
                  {service.icon}
                </div>
                <Card.Title className="fw-bold">{service.title}</Card.Title>
                <div>{service.description}</div>
                {/* ✅ Updated "Explore" button with Link to navigate to the service page */}
                <Link to={service.link} className="explore-link">Explore →</Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
       <Container fluid className="hero-about-section my-5 px-0">
  <Row className="align-items-center g-0">
    <Col md={6} className="p-0">
      <img
        src="/desginservice.jpg"
        alt="About NAEW"
        className="img-fluid rounded-3 about-img w-100"
      />
    </Col>
    <Col md={6} className="px-4 py-4">
      <div className="about-text">
        <h3 className="text-primary text-uppercase letter-spacing-2 mb-3">ABOUT US</h3>
        <p>
          <b>NAEW</b> was founded by EPC industry experts in 2022, offering comprehensive services in 3D modeling for <b>BIM-enabled progress monitoring</b> of large infrastructure projects.
        </p>
        <p>
          We specialize in <b>Design & Engineering</b> across Civil, Structural, Piping, and Electrical disciplines, with licensed software like <b>Tekla, Revit, Inventor, AutoCAD, Plant 3D</b>, and <b>Navisworks</b>.
        </p>
        <p>
          Our <b>Detailed Engineering Services</b> include 2D Drafting, Quantity Surveying, Bar Bending Scheduling, Piping ISO & Spooling.
        </p>
        <p>
          NAEW is also pioneering innovations in these areas through <b>AI</b> and smart IT solutions.
        </p>
      </div>
    </Col>
  </Row>
</Container>


    </Container>
  );
};

export default Services;
